module.exports = __webpack_public_path__ + "static/media/favebiz-login.87ef6554.jpg";